module.exports = __webpack_public_path__ + "static/media/Head.cfd92509.png";